export default __webpack_public_path__ + "static/media/Netent.17fdd848.png";